import { useState } from 'react';
import { SummaryJobRiskFactors } from '../../SummaryRisk.types';
import { downloadFile } from '../../services';
import { listKindEnum } from './RiskFactors';
import { useToast } from '@welbe/web-design-system';

export const useRiskFactors = () => {
	const { toast } = useToast();
	const [loadingFile, setLoadingFile] = useState(false);
	const [listKind, setListKind] = useState<listKindEnum>(
		listKindEnum.biggerList,
	);

	const handleListKind = (kind: listKindEnum) => {
		setListKind(kind);
	};

	const handleOpenFile = async (factor: SummaryJobRiskFactors) => {
		try {
			setLoadingFile(true);
			const { data } = await downloadFile(factor.jobProfileRiskFactorId);
			window.open(data?.content);
		} catch {
			toast.error('Hubo un error al intentar abrir lo documento.');
		} finally {
			setLoadingFile(false);
		}
	};

	return {
		listKind,
		loadingFile,
		handleOpenFile,
		handleListKind,
	};
};
